import { useMutation } from '@tanstack/react-query';

export default function useUploadEml() {
  return useMutation({
    mutationFn: async ({ link, blob }: { link: string; blob: Blob }) => {
      const result = await fetch(link, {
        method: 'PUT',
        headers: {
          'content-type': 'message/rfc822',
        },
        body: blob,
      });

      if (!result.ok) {
        const errorBody = await result.text();

        throw new Error(
          `Uploading eml failed (${result.status}): ${errorBody}`,
        );
      }

      return result;
    },
  });
}
